import React, {useCallback} from "react";
import {SendMoneyOptions, ZambiaSendMoneyOptions} from "./SendMoneyDropdown.constants";
import {openAddFundsModal, openZambiaAddFundsModal} from "../../../redux/accounts/slice/accountsSlice";
import {useDispatch, useSelector} from "react-redux";

import DropdownHead from "../../General/Dropdown/DropdownComponents/DropdownHead";
import DropdownLink from "../../General/Dropdown/DropdownComponents/DropdownLink";
import {IRootState} from "../../../redux/rootReducer";
import {useHistory} from "react-router-dom";

function SendMoneyDropdown(): JSX.Element {
	const history = useHistory();
	const dispatch = useDispatch();

	const main = useSelector((state: IRootState) => state.init.main);
	const isNigeria = useSelector((state: IRootState) => state.init.main?.companyDetails?.company.isNigeria);

	const handleOpenAddFundsModal = useCallback(() => {
		dispatch(isNigeria ? openAddFundsModal() : openZambiaAddFundsModal());
	}, [isNigeria]);

	return (
		<>
			<DropdownHead
				placeholder={<span className="text-sm text-white subpixel-antialiased">Send Money</span>}
				placement="right"
				size="sm"
				filled
				clickAndClose
				noOutlineBorder
			>
				{main &&
					main.companyDetails.accounts.length > 1 &&
					(isNigeria ? SendMoneyOptions : ZambiaSendMoneyOptions).map((option, index) => {
						return (
							<DropdownLink key={index} onClick={() => option.onClick(history, handleOpenAddFundsModal)} isLink>
								<div className="flex items-center justify-start px-4">
									<span className="text-xl ">{option.icon}</span>
									<div className="ml-4 inline items-center justify-center text-sm"> {option.text}</div>{" "}
								</div>
							</DropdownLink>
						);
					})}
				{main &&
					main.companyDetails.accounts.length < 2 &&
					(isNigeria ? SendMoneyOptions : ZambiaSendMoneyOptions)
						.filter((el) => el.text !== "Transfer Between Accounts")
						.map((option, index) => {
							return (
								<DropdownLink key={index} onClick={() => option.onClick(history, handleOpenAddFundsModal)} isLink>
									<div className="flex items-center justify-start px-4">
										<span className="text-xl ">{option.icon}</span>
										<div className="ml-4  inline items-center justify-center text-sm"> {option.text}</div>{" "}
									</div>
								</DropdownLink>
							);
						})}
				{/* {canShowPreReleaseFeatures &&
					SendMoneyOptionsPreRelease &&
					main &&
					main.companyDetails.accounts.length > 1 &&
					SendMoneyOptionsPreRelease.map((option, index) => {
						return (
							<DropdownLink key={index} onClick={() => option.onClick(history, handleOpenAddFundsModal)} isLink>
								<div className="flex items-center justify-start px-4">
									<span className="text-xl ">{option.icon}</span>
									<div className="ml-4 inline items-center justify-center text-sm"> {option.text}</div>{" "}
								</div>
							</DropdownLink>
						);
					})}
				{canShowPreReleaseFeatures &&
					SendMoneyOptionsPreRelease &&
					main &&
					main.companyDetails.accounts.length < 2 &&
					SendMoneyOptionsPreRelease.filter((el) => el.text !== "Transfer Between Accounts").map((option, index) => {
						return (
							<DropdownLink key={index} onClick={() => option.onClick(history, handleOpenAddFundsModal)} isLink>
								<div className="flex items-center justify-start px-4">
									<span className="text-xl ">{option.icon}</span>
									<div className="ml-4  inline items-center justify-center text-sm"> {option.text}</div>{" "}
								</div>
							</DropdownLink>
						);
					})} */}
			</DropdownHead>
		</>
	);
}

export default SendMoneyDropdown;
